import React, { useState, useEffect } from 'react';
import OrderManagementHeader from './OrderManagementHeader';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Grid, Container, Card, Box, Button, Stepper, Step, StepLabel } from '@mui/material';
import Footer from 'src/components/Footer';
import OrdersManagementContent from './OrdersManagementContent';

const OrdersManagement = () => {
  // Add state for tracking the current step in the form
  const [currentStep, setCurrentStep] = useState(0);
  return (
    <>
      <title>Orders</title>
      <PageTitleWrapper>
        <OrderManagementHeader />
      </PageTitleWrapper>
      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>

            <Card>
              <OrdersManagementContent  />

            </Card>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </>
  );
};

export default OrdersManagement;
